import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        modelValue: String,
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        disabled: Boolean,
        borderless: Boolean,
        center: Boolean
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        return { value };
    }
});
